var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var toPropertyKey = require("./toPropertyKey.js");
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    _Object$defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;


// WEBPACK FOOTER //
// ../node_modules/@babel/runtime-corejs2/helpers/defineProperty.js